import { Link } from 'react-router-dom';
import { TypewriterText } from '../hooks/useTypewriter';
import { useCopy, sections, Prose } from '../components/Copy';

function Actions() {
  return (
    <div className="mt-8 flex flex-wrap items-center gap-3">
      <a href="/api/download/app/mac" download
        className="inline-flex border border-white px-6 py-3 text-base text-white lowercase hover:bg-white hover:text-black transition-all duration-300 rounded-full glow-hover"
        data-testid="about-download-mac-btn">
        download for mac
      </a>
      <Link to="/downloads" className="inline-flex text-sm text-white/50 hover:text-white/90 lowercase transition-all duration-300 px-4 py-3"
        data-testid="about-downloads-link">
        downloads →
      </Link>
      <Link to="/runtimes/current" className="inline-flex text-sm text-white/50 hover:text-white/90 lowercase transition-all duration-300 px-4 py-3"
        data-testid="about-tech-specs-link">
        how it works →
      </Link>
    </div>
  );
}

// the words are backend/content/about.md (also served as /api/about.md)
export default function About() {
  const text = useCopy('about');
  const elements = [];
  let titles = 0;
  sections(text).forEach((s, i) => {
    if (s.level === 1) {
      titles += 1;
      elements.push(
        <h2 key={`t${i}`} className={`text-3xl lg:text-4xl font-bold text-white lowercase mb-6 ${titles === 1 ? 'crt-aberrate' : 'mt-20'}`}>
          {titles === 1 ? <TypewriterText text={s.title} speed={55} startDelay={150} /> : s.title}
        </h2>
      );
    } else if (s.level === 2) {
      elements.push(<h3 key={`h${i}`} className="text-white lowercase text-lg mt-12 mb-3">{s.title}</h3>);
    }
    if (s.body) elements.push(<Prose key={`b${i}`} className={s.level === 1 && titles === 1 ? 'copy-lead' : ''}>{s.body}</Prose>);
    if (s.level === 1 && titles === 1) elements.push(<Actions key="actions" />);
  });

  return (
    <div className="min-h-screen bg-black py-12 lg:py-24 px-6 lg:px-8 page-wrapper" data-testid="about-page">
      <div className="max-w-2xl mx-auto">
        {text === null ? <p className="text-[#555555] lowercase text-sm animate-pulse">loading…</p> : elements}
      </div>
    </div>
  );
}
